var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 8C20.0007 8.31153 19.8922 8.61344 19.6934 8.85333L13.7201 16L19.4801 23.16C19.5908 23.2964 19.6735 23.4533 19.7234 23.6218C19.7733 23.7902 19.7895 23.9669 19.7709 24.1416C19.7523 24.3163 19.6994 24.4856 19.6151 24.6398C19.5309 24.794 19.417 24.93 19.2801 25.04C19.1437 25.1508 18.9867 25.2335 18.8183 25.2834C18.6498 25.3333 18.4732 25.3494 18.2985 25.3308C18.1238 25.3122 17.9545 25.2593 17.8003 25.1751C17.6461 25.0908 17.5101 24.977 17.4001 24.84L10.9601 16.84C10.7639 16.6014 10.6567 16.3022 10.6567 15.9933C10.6567 15.6845 10.7639 15.3852 10.9601 15.1467L17.6267 7.14666C17.7387 7.01165 17.8761 6.90005 18.0313 6.81824C18.1864 6.73644 18.3561 6.68605 18.5308 6.66994C18.7054 6.65384 18.8815 6.67236 19.049 6.72441C19.2164 6.77647 19.372 6.86106 19.5067 6.97333C19.6597 7.0974 19.7832 7.25381 19.8685 7.43133C19.9538 7.60885 19.9988 7.80305 20.0001 8Z",
    fill: "#676C77"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/backArrowIcon.47778801.svg";
export { ForwardRef as ReactComponent };